import { getVarConfig } from './environment';
import fetchAPI from './fetchAPI';

const logData = ({ step, extra = {}, error = null }) => {
  const service = getVarConfig({ key: 'REACT_APP_SERVICES_GET_ENROLLMENT' }) + '/logger';

  const payload = {
    step,
    timestamp: new Date().toISOString(),
    ...extra,
    ...(error && {
      errorMessage: error?.message || String(error),
      errorStack: error?.stack,
    }),
  };

  return fetchAPI({
    service,
    protocol: 'POST',
    params: { extra: payload },
  }).catch(() => {});
};

export default logData;
